import { ColumnConfig } from '@/components/table/Table';
import { Option } from '@/components/inputs/AutocompleteInput';

export const assetSelectorColumns: ColumnConfig[] = [
  { label: 'Tipo', field: 'type' },
  { 
    label: 'Marca', 
    field: 'brand',
    render: (value: { name: string } | string | null) => {
      if (typeof value === 'string') return value;
      if (value?.name) return value.name;
      return 'Sin marca';
    }
  },
  { 
    label: 'Modelo', 
    field: 'model',
    render: (value: { name: string } | string | null) => {
      if (typeof value === 'string') return value;
      if (value?.name) return value.name;
      return 'Sin modelo';
    }
  },
  { label: 'Número de serie', field: 'serialNumber' },
  { label: 'Condición', field: 'condition' },
  { label: 'Estado', field: 'status' },
  {
    label: 'Asignado a',
    field: 'userDisplay',
    render: (value: string) => {
      if (value === 'No asignado') {
        return (<span className="text-green-600 font-medium">Disponible</span>);
      }
      return (<span className="text-orange-600 font-medium">{value}</span>);
    }
  },
];

export function mapAssetsToTableData(assetsOptions: Option[]): any[] {
  return assetsOptions.map((opt) => ({
    id: opt.data.id,
    type: opt.data.type,
    brand: opt.data.brand,
    model: opt.data.model,
    serialNumber: opt.data.serialNumber,
    condition: opt.data.condition,
    status: opt.data.status,
    user: opt.data.user?.fullName || 'No asignado',
    asset: opt.data,
  }));
}
